import { orderDetailsButtonSetStyles as styles } from "@iewc/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";

delete styles.rmaButton?.buttonType;
styles.rmaButton = {
    variant: "tertiary",
};

styles.changeOrderButton = {
    variant: "tertiary",
};
